module.exports = __webpack_public_path__ + "static/img/delete_copy.8f38194.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/delete_copy.png
// module id = gNyG
// module chunks = 1